<template>
  <div style="padding: 20px;">
    <h3>饲养信息</h3>
    <br>
    <a-form :form="form" labelAlign="left" >
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="饲养品种">
            <a-select
              placeholder="请选择"
              v-decorator="['feedVariety',{rules:[{required: true, message: '请选择饲养品种'}]}]"
            >
              <a-select-option v-for="el in feedVarietyList" :key="el.id" :value="el.name">
                {{ el.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲料品牌">
            <a-select
              placeholder="请选择"
              v-decorator="['feedBrand',{
                rules:[{required: true, message: '请选择饲料品牌'}],
                initialValue:`新希望`
              }]"
              @change="handleChange"
            >
              <a-select-option v-for="el in feedBrandList" :key="el.varietyDepotCode" :value="el.varietyDepotName">
                {{ el.varietyDepotName}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="免疫情况">
            <a-radio-group v-decorator="['vaccination']">
              <a-radio v-for="el in vaccinationList" :key="el.vaccinationValue" :value="el.vaccinationValue ">
                {{ el.vaccinationName }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-table 
            :columns="inputfeedInfoColumns" 
            :data-source="feedInfoList" 
            :pagination="false" 
            :rowKey="(record, index) => { return index }">
            <span slot="dayTitle"><span style="color: red">*</span> 日期</span>
            <span slot="day" slot-scope="text, record ,index">
              <a-date-picker 
                v-model="record.day" 
                valueFormat="YYYY-MM-DD" 
                :disabled-date="index == 0 ? disabledStartDate : disabledEndDate"
              />
            </span>
            <span slot="dayAge" slot-scope="text, record">
              <a-input-number
                placeholder="请输入"
                :min="1"
                :max="300"
                v-model="record.dayAge"
                :precision="2"
                @blur="verificationLegal(record,'dayAge')"
              />
            </span>
            <span slot="weightTitle"><span style="color: red">*</span> 均重（kg）</span>
            <span slot="weight" slot-scope="text, record">
              <a-input-number
                placeholder="请输入"
                :min="1"
                :max="300"
                v-model="record.weight"
                :precision="2"
                @blur="verificationLegal(record,'weight')"
              />
            </span>
            <span slot="numTitle"><span style="color: red">*</span> 数量（头）</span>
            <span slot="num" slot-scope="text, record">
              <a-input-number
                placeholder="请输入"
                :min="1"
                :max="1000000"
                v-model="record.num"
                @blur="verificationLegal(record,'num')"
              />
            </span>
          </a-table>
          <br>
        </a-col>
        <a-col :span="8">
          <a-form-item label="猪苗单价（元/头）">
            <a-input-number 
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="10000" 
              :precision="2"
              v-decorator="['pigletPrice']"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="卖猪价（元/kg）">
            <a-input-number 
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="300" 
              :precision="2"
              v-decorator="['pigSalePrice']"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-table 
            :columns="inputFeedStageColumns" 
            :data-source="feedStageList" 
            :pagination="false" 
            :rowKey="(record, index) => { return index }"
          >
            <template slot="stageType" slot-scope="t">{{ stagesObj[t] }}</template>
            <span slot="productNameTitle"><span style="color: red">*</span> 产品名称</span>
            <span slot="productName" slot-scope="text, record, index">
              <a v-if="form.getFieldValue('feedBrand') == '新希望' && !record.productName" 
                @click="handleClick(index)"
              >选择配方</a>
              <a v-else-if="form.getFieldValue('feedBrand') == '新希望' && record.productName" 
                @click="handleClick(index)"
              >{{record.productName}}</a>
              <a-input v-else style="width: 66.66%" placeholder="请输入" v-model="record.productName" :maxLength="50"/>
              <a-button v-if="form.getFieldValue('feedBrand') == '新希望' && record.productName" 
                style="margin-left: 10px" 
                @click="deleteProductName(record)"
              >删除</a-button>
            </span>
            <span slot="productTargetTitle"><span style="color: red">*</span> 产品定位</span>
            <span slot="productTarget" slot-scope="text, record">
              <a-select allowClear style="width: 66.66%;" v-model="record.productTarget" placeholder="请选择">
                <a-select-option 
                  v-for="el in productPositionList" 
                  :key="el.productPositionId" 
                  :value="el.productPositionName"
                >{{ el.productPositionName }}</a-select-option>
              </a-select>
            </span>
            <span slot="feedTerminalPriceTitle"><span style="color: red">*</span> 饲料终端价格（元/kg）</span>
            <span slot="feedTerminalPrice" slot-scope="text, record">
              <a-input-number
                style="width: 66.66%;"
                placeholder="请输入"
                :min="1"
                :max="100"
                v-model="record.feedTerminalPrice"
                :precision="2"
              />
            </span>
            <span slot="feedCostTitle"><span style="color: red">*</span> 总耗料量（kg）</span>
            <span slot="feedCost" slot-scope="text, record">
              <a-input-number
                style="width: 66.66%;"
                placeholder="请输入"
                :min="1"
                :max="10000000"
                v-model="record.feedCost"
                :precision="2"
              />
            </span>
          </a-table>
          <br>
        </a-col>
      </a-row>
    </a-form>
    <formula-modal 
      ref="formulaModal" 
      :visible="visible" 
      @isShow="isShow" 
      @getSelect="getSelect" 
      :selectFactory="selectFactory"
      :factoryId="factoryId"
    />
  </div>
</template>

<script>
import {inputfeedInfoColumns,inputFeedStageColumns} from '../Columns'
import {vaccinationList, productPositionList} from './Lists'
import FormulaModal from'./FormulaModal.vue'
import moment from 'moment';

export default {
  props:['selectFactory','factoryId','feedInfoList','pigLineFeedInfo','pigLineRaiseInfos'],
  components:{FormulaModal},
  data(){
    return{
      form: this.$form.createForm(this, { name: 'feedInfo' }),
      inputfeedInfoColumns,
      inputFeedStageColumns,
      feedBrandList:[],
      vaccinationList,
      productPositionList,
      visible: false,
      feedVarietyList:[],
      stagesObj:{
        PIGLET: '教槽',
        CHILDCARE_BEFORE: '保育前期',
        CHILDCARE_AFTER: '保育后期',
        LITTLE_PIG: '仔猪',
        MEDIUM: '生长猪',
        FATTENING_PIG: '育肥猪',
        LARGE_PIG: '大猪',
      },
      feedStageList:[]
    }
  },
  mounted() {
    this.feedStageListGet()
    this.feedBrandGet()
    if(this.$route.query.copyId) this.convert()
    this.form.setFieldsValue(this.pigLineFeedInfo)
    this.getFeedVarietyList()
  },
  methods:{
    feedStageListGet() {
      this.feedStageList.splice(0,this.feedStageList.length);
      const stages = Object.keys(this.stagesObj)
      stages.forEach(element => {
        this.feedStageList.push({
          nhfFormulaId:'',
          stageType:element,
          productName:'',
          productTarget:undefined,
          feedTerminalPrice:'',
          feedCost:'',
        })
      });
      if(this.pigLineRaiseInfos.length) {
        for(let a in this.feedStageList){
          for (let b in this.pigLineRaiseInfos){
            if(this.feedStageList[a].stageType == this.pigLineRaiseInfos[b].stageType && this.pigLineRaiseInfos[b].productName){
              this.feedStageList[a].feedCost = this.pigLineRaiseInfos[b].feedCost
              this.feedStageList[a].feedTerminalPrice = this.pigLineRaiseInfos[b].feedTerminalPrice
              this.feedStageList[a].nhfFormulaId = this.pigLineRaiseInfos[b].nhfFormulaId
              this.feedStageList[a].productName = this.pigLineRaiseInfos[b].productName
              this.feedStageList[a].productTarget = this.pigLineRaiseInfos[b].productTarget
              continue
            }
          }
        }
      }
    },
    sendData(){
      this.$emit('setFeedInfo', {feedInfoList:this.feedInfoList,feedStageList:this.feedStageList})
    },
    handleChange(){
      this.feedStageList.splice(0,this.feedStageList.length);
      const stages = Object.keys(this.stagesObj)
      stages.forEach(element => {
        this.feedStageList.push({
          nhfFormulaId:'',
          stageType:element,
          productName:'',
          productTarget:undefined,
          feedTerminalPrice:'',
          feedCost:'',
        })
      });
    },
    handleClick(index) {
      this.visible = true
      this.$refs.formulaModal.reset()
      this.$refs.formulaModal.initRecord(index)
    },
    isShow(val){
      this.visible = val
    },
    getSelect(val,index){
      this.feedStageList[index].productName = val[0].formulaName;
      this.feedStageList[index].nhfFormulaId = val[0].id
    },
    async feedBrandGet() {
      const res = await this.$http.get("/sat-ruminants/varietydepot/list", { params:{type:2, size:-1, labelCode:'swine'} })
      let { success, data } = res
      if (success) this.feedBrandList = data.records 
    },
    convert(){
      this.pigLineFeedInfo.vaccination = this.pigLineFeedInfo.vaccination ? 1 : 0
      this.feedInfoList[0].day = this.pigLineFeedInfo.intoDay
      this.feedInfoList[0].dayAge = this.pigLineFeedInfo.intoDayAge
      this.feedInfoList[0].num = this.pigLineFeedInfo.intoNum
      this.feedInfoList[0].weight = this.pigLineFeedInfo.avgInitialWeight
      this.feedInfoList[1].day = this.pigLineFeedInfo.outDay
      this.feedInfoList[1].dayAge = this.pigLineFeedInfo.outDayAge
      this.feedInfoList[1].num = this.pigLineFeedInfo.outNum
      this.feedInfoList[1].weight = this.pigLineFeedInfo.avgEndWeight
    },
    disabledStartDate(startValue) {
      const endValue = moment(this.feedInfoList[1].day,'YYYY-MM-DD')
      if (!startValue || !endValue) return false
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate(endValue) {
      const startValue = moment(this.feedInfoList[0].day,'YYYY-MM-DD')
      if (!endValue || !startValue) return false
      return startValue.valueOf() >= endValue.valueOf()
    },
    verificationLegal(record, title) {
      if(this.feedInfoList[0][title] && this.feedInfoList[1][title]){
        if(title == 'num' && record[title] && this.feedInfoList[0][title] < this.feedInfoList[1][title]) {
          this.$message.error('出栏数量不得大于入栏数量，请重新输入！')
          record[title] = ''
        }
        else if(title != 'num' && record[title] && this.feedInfoList[0][title] > this.feedInfoList[1][title]){
          if(title == 'dayAge') this.$message.error('出栏日龄不得小于入栏日龄，请重新输入！')
          if(title == 'weight') this.$message.error('结束体重不得小于初始体重，请重新输入！')
          record[title] = ''
        }
      }
    },
    async getFeedVarietyList(){
      let res = await this.$http.get("/sat-ruminants/animalvariety/list", { params:{VarietyDepotCode:'Swine',size: -1}})
      this.feedVarietyList = res.data.records
    },
    deleteProductName(record){
      record.productName = undefined
      record.nhfFormulaId = ''
    }
  }
}
</script>

<style>

</style>